import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import "./Faqs.css";
import blackarrow from "../../../assets/blackarrow.svg";

const Faqs = () => {
  return (
    <div className="faqs-section">
      <h1 className="faqs-text">FAQs</h1>
      <header className="App-header">
        <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="1" className="mt-5 text">
            <Accordion.Header>
              <p className="accordion-text">What is OVest?</p>
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              <p>
                OVest.ng (OSOURCE VESTMENT LTD) is a product of Osource Empire
                Limited. OVest was established with the Mission to help
                individuals, organizations and communities achieve financial
                security, build wealth and realize their dreams.
              </p>{" "}
              <p>
                OVest is a registered and thriving Investment and Funds
                Management Company managed by a team of experienced and
                competent professionals in the business of Foreign Exchange
                Trading, Agriculture, Real Estate, Small Businesses and other
                investment opportunities offered by the industry.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">Is the Business Duly Registered?</p>
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              Yes. OVest is a product of OSource Empire, a union of brands
              enriching lives and communities daily and we are duly registered
              with the Corporate Affairs Commission (RC 1776455).
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">Can I have multiple accounts?</p>{" "}
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              In OVest, multiple accounts are not allowed for the purpose of
              proper investment management and prevention of fraud, but you can
              have multiple active investments running simultaneously.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">
                Can I have multiple investments running?
              </p>{" "}
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              Yes, you can. You can invest in another investment plan offered by
              OVest before the maturity of your current plan or at any time.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">
                How are you able to offer higher returns?
              </p>{" "}
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              OVest is managed by a team of experienced and competent
              professionals in the finance and investment industry within and
              outside the country. The professionals amply understand the
              volatility that clouds the usage and sourcing of the market. They
              are duly learned in the field and as such, they use the best
              analysis and risk management solutions to operate in all
              investment opportunities offered by the industry to ensure optimum
              returns consistently.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">How much do you charge?</p>{" "}
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              OVest is completely free (Zero SMS fees, zero account maintenance
              fees).
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">When can I withdraw my money?</p>{" "}
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              You can only withdraw at the set maturity date. You can choose to
              withdraw some or all of your capital together with the interest.
              You can decide to rollover the plan for another period or withdraw
              part or everything you have invested. Rolling over matured plans
              for another period makes it possible to enjoy compound returns.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">
                Can I Invest if I am outside Nigeria?
              </p>{" "}
            </Accordion.Header>
            <Accordion.Body className="accordion-bodyText">
              Yes! All you have to do is to follow the same investment process
              stated above. Fill in your profile correctly and if you face any
              difficulty, please contact us at{" "}
              <a href="mailto:support@myovest.com">support@myovest.com.</a>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="9" className="mt-3 text">
            <Accordion.Header>
              <p className="accordion-text">Can I have multiple accounts?</p>{" "}
            </Accordion.Header>
            <Accordion.Body>
              In OVest, multiple accounts are not allowed for the purpose of
              proper investment management and prevention of fraud, but you can
              have multiple active investments running simultaneously.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </header>
      {/* <div className="faq">
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          
        </div>
        <div className="faqs-details">
          <p>Is OVest registered</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>How do you make money</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
        <div className="faqs-details">
          <p>Is my money safe with OVest</p>
          <img src={blackarrow} alt="black-arrrow" />
        </div>
      </div> */}
    </div>
  );
};

export default Faqs;
